<template>
  <div class="seomain">
    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list-xs" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-top-xs">
            <div class="t-tit-xs">SKU:{{ v.sku }}</div>
          </div>
          <div class="st-list-main">
            <p>库存编码：{{ v.inventory_code }}</p>
            <p>商品名称：{{ v.product_name }}</p>
            <p>品牌：{{ v.brand }}</p>
            <p>型号：{{ v.model }}</p>
            <p>销售数量：{{ v.total }}</p>
            <p>销售价格：{{ v.amount }}元</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialog_num: "",
      show: !1,
      stlist: [],
      stinfo: {},
      oneinfo: {},
      paramsid: 0,
      activeid: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    get_st_info: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetXiaoshouInfo, { id: paramsid }).then((res) => {
        this.stlist = res.data;
        this.stinfo = res.data;
      });
    },
  },
  created() {
    this.get_st_info();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "销售" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tab-content .st-list-xs {
  margin-bottom: 10px;
  background: #fff;
}
.st-list-top-xs {
  background: #677588;
  text-align: center;
}
.t-tit-xs {
  color: #fff;
  line-height: 2.6;
}
.st-list-main {
  padding: 10px 15px;
}
</style>
